<template>
  <div class="area P3">
    <div class="d d_list d_list2">
      <div :class="`d bar ${flag && 'bar_on'}`">
        <p class="a_back"><i class="iC i_back" @click="goBack"></i></p>
        <div class="d d_sel" @click="showStatus()">
          <div class="fl">{{ statusTitle }}</div>
          <i class="iC i_jt2"></i>
        </div>
        <div class="d d_stip d_stip2">
          <div class="d d_stip_i">
            <ul class="u_sel2">
              <li
                v-for="item in statusList"
                :key="item.status"
                :class="item.status == status && 'hover'"
              >
                <p @click="selectStatus(item)">{{ item.name }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 添加检索 -->
      <div v-if="roldId > 2">
        <select-item
          title="指定表单"
          :value="formName"
          :list="forms"
          :handlerSelect="selectFormId"
          name="name"
        ></select-item>
        <comp-address
          :province="province"
          :city="city"
          :district="district"
          :provinceCode="provinceCode"
          :cityCode="cityCode"
          :districtCode="districtCode"
          :selectArea="selectArea"
          :type="'search'"
        ></comp-address>
        <select-item
          title="指定身份"
          :value="identityName"
          :list="roleList"
          :handlerSelect="selectRole"
          name="roleName"
        ></select-item>
      </div>
    </div>
    <p class="p_ts fcG" v-if="status == 0">待审核信息：{{ total }}条</p>
    <div class="d d_tb">
      <ul class="u4 u4_tit2">
        <li>提交人</li>
        <li>填报项目</li>
        <li v-if="roldId == 5">填报学校</li>
        <li>提交时间</li>
        <li>审核状态</li>
      </ul>
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        class="order-list-refresh"
      >
        <!-- @offset="10" -->
        <!-- :error.sync="error"
          error-text="请求失败，点击重新加载" -->
        <!-- @load="onLoad"
          immediate-check="true" -->
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
          offset="100"
        >
          <div class="list-cnt">
            <van-radio-group v-model="changeUser" @change="updateChecked">
              <!-- <ul :class="`u u_tb ${status == 0  ? 'u_cy2' : ''}`" v-if="list.length > 0"> -->
              <ul :class="`u u_tb u_cy2`" v-if="list.length > 0">
                <li
                  v-for="(item, index) in list"
                  :class="index == 0 && 'l_fir'"
                  :key="item.id"
                >
                  <div class="fl">
                    <!-- v-if="status == 0" -->
                    <van-radio :name="item.id" class="radio"></van-radio>
                    <h4
                      class="cap4"
                      @click="
                        goDetail(
                          item.status,
                          item.id,
                          item.userName,
                          item.createTime,
                          item.formId,
                          item.vueUrl
                        )
                      "
                    >
                      {{ item.userName }}
                    </h4>
                    <p
                      class="oneLine"
                      @click="
                        goDetail(
                          item.status,
                          item.id,
                          item.userName,
                          item.createTime,
                          item.formId,
                          item.vueUrl
                        )
                      "
                    >
                      {{ item.formName }}
                    </p>
                    <p class="fcG2" v-if="item.school == null">
                      {{ item.province || "" }}{{ item.city || ""
                      }}{{ item.district || "" }}
                    </p>
                    <p class="fcG2">{{ item.school }}</p>
                    <p
                      class="fcG2"
                      @click="
                        goDetail(
                          item.status,
                          item.id,
                          item.userName,
                          item.createTime,
                          item.formId,
                          item.vueUrl
                        )
                      "
                    >
                      {{ unixTimeToDateTime(item.createTime) }}
                    </p>
                  </div>
                  <p :class="`btn5 ${statusClass(item.status)}`">{{ item.statusStr }}</p>
                </li>
              </ul>
            </van-radio-group>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <div class="ft ft_sh" v-if="status == 0">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(1)">通过</p>
        <p @click="operation(2)">不通过</p>
      </div>
    </div>
    <div class="ft ft_sh" v-if="status == 1">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(2)">不通过</p>
      </div>
    </div>
    <div class="ft ft_sh" v-if="status == 2">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(1)">通过</p>
      </div>
    </div>
    <t-Message
      :visible="isVisible"
      :handler="handlerStatus"
      :handlerClose="handlerClose"
      placeholder="请输入原因"
      title="提示"
      cnt="确定要不通过此条内容吗？"
    ></t-Message>
  </div>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { getAuditList, setAuditData } from "@/service/form";
import { unixTimeToDateTime, tipsMsg, getRoleId } from "@/common/js";
import { forms } from "@/common/form/index";
import tMessage from "@/components/InputMessage.vue";
import compAddress from "@/components/Address";
import selectItem from "@/components/SelectItem";
export default {
  components: {
    tMessage,
    compAddress,
    selectItem,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const { proxy } = getCurrentInstance();
    const state = reactive({
      isVisible: false,
      page: 1,
      size: 50,
      list: [],
      status: 0,
      total: 0,
      totalPage: 0,
      loading: false,
      finished: false,
      finishedText: "没有更多了",
      refreshing: false,
      flag: false,
      statusTitle: "请选择要处理的填报信息",
      statusList: [
        { name: "待审核", status: 0 },
        { name: "已通过", status: 1 },
        { name: "未通过", status: 2 },
      ],
      changeUser: "",
      //  error: false,
      roldId: 5,
      // 搜索
      province: "",
      provinceCode: "",
      city: "",
      cityCode: "",
      district: "",
      districtCode: "",
      roleList: [],
      identityName: "",
      identity: -1,
      formId: -1,
      formName: "",
    });

    onMounted(async () => {
      //  isBack = 0
      const rId = await getRoleId();
      if (rId) {
        state.roldId = rId;
      }
      const { status } = route.query;
      if (status) {
        state.status = status;
        const statusItem = state.statusList.filter((res) => res.status == status);
        if (statusItem.length > 0) {
          state.statusTitle = statusItem[0].name;
        }
      }

      // 主动加载数据
      onLoad();
      // 加载数据
      // state.loading = true;
      // 获取当前登录人可查看的省市区
      getArea();
    });

    // 展示筛选状态
    const showStatus = () => {
      state.flag = !state.flag;
    };

    // 筛选状态对应数据
    const selectStatus = ({ status, name }) => {
      state.status = status;
      state.statusTitle = name;
      showStatus();
      initData();
      loadData();
    };

    const selectRole = (role) => {
      state.identity = role.roleId;
      state.identityName = role.roleName;
      state.page = 1;
      state.totalPage = 1;
      state.list = [];
      onLoad();
    };

    const selectFormId = (val) => {
      console.log("val", val);
      state.formId = val.id;
      state.formName = val.name;
      state.page = 1;
      state.totalPage = 1;
      state.list = [];
      onLoad();
    };

    // 关闭确认弹框提示
    const handlerClose = () => {
      state.isVisible = false;
    };
    // 判断不通过填写原因
    const handlerStatus = async (value) => {
      const { changeUser } = state;
      if (value == "") {
        tipsMsg("提示", "请填写不通过原因");
        return false;
      } else {
        setAuditDataFn(changeUser, 2, value);
      }
    };
    // 选择省市区筛选
    const selectArea = (area) => {
      let defaultTxt = "不限";
      if (JSON.stringify(area).indexOf(defaultTxt) != -1) {
        const { province = "", city = "", district = "" } = area;
        if (province != "" && province == defaultTxt) {
          state.province = defaultTxt;
          state.city = defaultTxt;
          state.district = defaultTxt;
        }
        if (city != "" && city == defaultTxt) {
          state.city = defaultTxt;
          state.district = defaultTxt;
        }
        if (district != "" && district == defaultTxt) {
          state.district = defaultTxt;
        }
      } else {
        // 合并
        Object.assign(state, area);
      }
      state.page = 1;
      state.totalPage = 1;
      state.list = [];
      onLoad();
    };

    // 获取当前登录人可查看的省市区
    const getArea = async () => {
      // 回显省市区
      const {
        roleList,
        province,
        provinceCode,
        city,
        cityCode,
        district,
        districtCode,
      } = store.state.info;

      if (roleList.length > 0) {
        let newList = JSON.parse(JSON.stringify(roleList));
        newList.unshift({ roleId: -1, roleName: "不限" });
        state.roleList = newList;
      }
      if (province != null) {
        state.province = province;
        state.provinceCode = provinceCode;
      }
      if (city != null) {
        state.city = city;
        state.cityCode = cityCode;
      }
      if (district != null) {
        state.district = district;
        state.districtCode = districtCode;
      }
    };

    const initData = () => {
      state.page = 1;
      state.list = [];
    };

    const onLoad = () => {
      console.log("onLoad", state.loading);

      if (state.loading) {
        return;
      }
      console.log("onLoad");

      if (!state.refreshing && state.page < state.totalPage) {
        state.page = state.page + 1;
      }
      if (state.refreshing) {
        state.list = [];
        state.refreshing = false;
      }
      // 将 loading 设置为 true，表示处于加载状态
      state.loading = true;
      loadData();
    };
    const loadData = async () => {
      const rId = await getRoleId();
      const { status, size, page, province, city, district, identity, formId } = state;
      let p = province,
        c = city,
        d = district;
      if (province == "不限") {
        p = "";
      }
      if (city == "不限") {
        c = "";
      }
      if (district == "不限") {
        d = "";
      }
      let param = {
        status,
        size,
        page,
        province: p,
        city: c,
        district: d,
        roleId: identity,
        formId,
      };
      if (rId <= 2) {
        param = {
          status,
          size,
          page,
        };
      }
      console.log('---', param);
      try {
        const {
          code,
          data,
          data: { list = [] },
        } = await getAuditList(param);
        console.log("data-->", data);
        if (code === 10000) {
          if (list) {
            state.list = state.list.concat(list);
          }
          if (state.status == 0) {
            state.total = data.total;
          }
          state.totalPage = data.totalPage;
          state.loading = false;
          if (state.page >= data.totalPage) state.finished = true;
          // state.error = false;
        } else {
          state.loading = false;
        }
      } catch (error) {
        state.loading = false;
        state.finished = true;
        state.finishedText = "服务异常，请稍后重试";
      }
    };

    const goDetail = (status, id, username, time, formId,vueUrl) => {
      router.push({
        path: "/organization/auditor/detail",
        query: { status, oid: id, username, time, formId,vueUrl  },
      });
    };

    const onRefresh = () => {
      state.refreshing = true;
      state.finished = false;
      state.loading = true;
      state.page = 1;
      onLoad();
    };
    const goBack = () => {
      // router.go(-1);
      router.push({ path: "/organization/management" });
    };
    const statusClass = (status) => {
      let sClass = "";
      switch (status) {
        case 0:
          sClass = "btn5_1";
          break;
        case 1:
          sClass = "btn5_3";
          break;
        case 2:
          sClass = "btn5_2";
          break;
      }
      return sClass;
    };
    const operation = async (status) => {
      const { changeUser } = state;
      if (!changeUser) {
        tipsMsg("提示", "请选择需要操作的信息");
        return false;
      }
      if (status == 2) {
        state.isVisible = 2;
        return false;
      }

      let msg = "通过";
      if (status == 2) {
        msg = "不通过";
      }

      let type = 1;
      if (status == 2) {
        type = 3;
      }
      proxy.$tipsMessage(
        true,
        type,
        "提示",
        `确定要${msg}此条内容吗？`,
        async () => {
          setAuditDataFn(changeUser, status);
          proxy.$tipsMessage(false);
        },
        true
      );
    };

    const setAuditDataFn = async (changeUser, status, value) => {
      let param = {
        dataIds: [changeUser],
        status,
      };
      if (status == 2) {
        param.reason = value;
      }
      const { code } = await setAuditData(param);
      if (code === 10000) {
        onRefresh();
        state.changeUser = "";
        state.isVisible = false;
      }
    };
    const updateChecked = (e) => {
      if (e && e != "") {
        state.changeUser = e;
      }
    };
    return {
      ...toRefs(state),
      selectStatus,
      showStatus,
      unixTimeToDateTime,
      statusClass,
      onLoad,
      onRefresh,
      goBack,
      operation,
      updateChecked,
      goDetail,
      handlerClose,
      handlerStatus,
      selectArea,
      selectRole,
      forms,
      selectFormId,
    };
  },
};
</script>
<style lang="less" scoped>
.f_opa {
  justify-content: center;
  align-items: center;
  display: flex;
}
.f_opa p {
  display: inline-block;
  color: #0e97f9;
  margin: 0 0.107rem;
}
.u4 li {
  width: 20%;
}
.u4_tit2 {
  display: flex;
  justify-content: space-around;
}
.order-list-refresh {
  //   overflow-y: scroll;
  //   height: 100%;
}
// .d_tb {
//   overflow-y: scroll;
//   height: 100%;
// }
// .list-cnt {
//     overflow-y: scroll;
//      height: 100%;
// }
</style>
